// extracted by mini-css-extract-plugin
export default {"login":"Login_login__tQVQx","panel":"Login_panel__55vPr","fancy":"Login_fancy__0WnJW","error":"Login_error__5wXwI"};